import { CatalogEnvService } from '@aipb/gulliver/catalog/env';
import { PreparedQueryModel } from '@aipb/gulliver/catalog/model';
import { DashboardComponent } from '@aipb/gulliver/frame/feature-dashboard';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslocoService } from '@jsverse/transloco';
import { RouterRepository } from '@ngneat/elf-ng-router-store';
import { combineLatest, Observable, startWith } from 'rxjs';
import { map } from 'rxjs/operators';
import { DashboardCardListComponent } from '../../components';
import { SearchUseCase } from '../../usecases';

@Component({
  selector: 'cat-dashboard-page',
  templateUrl: './dashboard-page.component.html',
  styleUrls: ['./dashboard-page.component.scss'],
  standalone: true,
  imports: [CommonModule, MatCardModule, DashboardCardListComponent, DashboardComponent]
})
export class DashboardPageComponent {
  search = inject(SearchUseCase);
  private catalogEnv = inject(CatalogEnvService);
  preparedQueryMode = this.catalogEnv.env.preparedQueriesMode;
  preparedQuerySimple = this.catalogEnv.env.preparedQueriesSimple;
  private routerRepository = inject(RouterRepository);
  private transloco = inject(TranslocoService);
  queries$: Observable<PreparedQueryModel[]> = combineLatest([
    this.routerRepository.selectParams('configId'),
    this.transloco.langChanges$.pipe(startWith(this.transloco.getActiveLang()))
  ]).pipe(map(([configId, lang]) => this.catalogEnv.env.getPreparedQueriesTranslated(lang)));
}
